import styled from 'styled-components';
import { responsiveStyles } from '../../utils/responsiveStyles';
import { mapStyle } from '../../utils/mapStyle';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { AlignMap } from './LayoutItem.types';
export const StyledLayoutItem = styled.div `
  ${(props) => responsiveStyles({
    'align-self': mapStyle(props.align, AlignMap),
    'flex-basis': props.basis,
    'flex-grow': props.grow,
    'flex-shrink': props.shrink,
}, props.theme.breakpoints)}
  ${injectSpacing('margin')}
`;
//# sourceMappingURL=LayoutItem.styles.js.map